"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectedReleaseSearchPage = exports.DefaultReleaseSearchPage = void 0;
const react_1 = __importStar(require("react"));
const react_helmet_1 = __importDefault(require("react-helmet"));
const react_redux_1 = require("react-redux");
const react_bootstrap_1 = require("react-bootstrap");
const spa_core_1 = require("@episerver/spa-core");
const foundation_settings_1 = require("@episerver/foundation-settings");
const LoadingSpinner_1 = require("app/Components/Shared/LoadingSpinner");
const date_utils_1 = require("app/utils/date.utils");
const Button_1 = __importStar(require("app/Components/Common/Button"));
const ReleasesMonthFilter_1 = __importDefault(require("app/Components/Common/ReleasesMonthFilter/ReleasesMonthFilter"));
const PageTop_1 = __importDefault(require("app/Components/Shared/PageTop"));
const Glossary_1 = __importDefault(require("app/Components/Shared/Glossary"));
require("./ReleaseSearchPage.scss");
const GlossaryService_1 = __importDefault(require("app/Components/Common/GlossaryService"));
const TabFunctions_1 = require("app/Components/Common/TabFunctions");
const react_router_1 = require("react-router");
const DefaultReleaseSearchPage = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
    const settingsService = (0, foundation_settings_1.useSettings)();
    const api = (0, spa_core_1.useContentDeliveryAPI)();
    const ctx = (0, spa_core_1.useEpiserver)();
    const location = (0, react_router_1.useLocation)();
    const [layoutSettings, setLayoutSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LayoutSettings'));
    const [labelSettings, setLabelSettings] = (0, react_1.useState)(settingsService.getContainerOnServer('LabelSettings'));
    const [categoryList, setCategoryList] = (0, react_1.useState)(settingsService.getContainerOnServer('Categories'));
    const itemStep = ((_a = props.data.showMoreCount) === null || _a === void 0 ? void 0 : _a.value) > 0 ? (_b = props.data.showMoreCount) === null || _b === void 0 ? void 0 : _b.value : 10;
    const language = props.currentLanguage;
    const [query, setQuery] = (0, react_1.useState)('');
    const [disableShowMore, setDisableShowMore] = (0, react_1.useState)(false);
    const [childrens, setChildrens] = (0, react_1.useState)();
    const [showReleaseFilter, setShowReleaseFilter] = (0, react_1.useState)(false);
    const [totalReleases, setTotalReleases] = (0, react_1.useState)('');
    const [firstload, setFirstLoad] = (0, react_1.useState)(true);
    const [loading, setLoading] = (0, react_1.useState)(false);
    const tabContent = [];
    const allBlogsTab = { id: 'all', filterText: (_c = props.data.showAllTabText) === null || _c === void 0 ? void 0 : _c.value, content: [], resultText: (_d = props.data.showingAllText) === null || _d === void 0 ? void 0 : _d.value };
    const stockTab = { id: null, subIds: [], filterText: null, content: [], resultText: '', catname: '' };
    const pressTab = { id: null, subIds: [], filterText: null, content: [], resultText: '', catname: '' };
    const newsTab = { id: null, subIds: [], filterText: null, content: [], resultText: '', catname: '' };
    const [selectedTab, setSelectedTab] = (0, react_1.useState)({ count: itemStep, skip: 0, filter: '', yearAndMonthFilter: '', activeTab: allBlogsTab, query: '' });
    const releases = [];
    const defaultStockFilters = [];
    const defaultNewsFilters = [];
    const [isTabsOpen, setIsTabsOpen] = (0, react_1.useState)(false);
    let tabElement = react_1.default.createElement("div", { className: 'col-12 d-flex justify-content-center' },
        react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, null));
    const history = (0, react_router_1.useHistory)();
    // gets translations for category tabs
    if ((categoryList === null || categoryList === void 0 ? void 0 : categoryList.categories.length) > 0) {
        categoryList.categories.forEach(cat => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            const textArr = cat.displayTexts;
            if (cat.type === 'StockExchangeRelease') {
                stockTab.id = cat.id;
                stockTab.catname = cat.displayTexts[0].displayText.toLowerCase().replace(/\s|&/g, '');
                stockTab.resultText = (_a = props.data.showingStockText) === null || _a === void 0 ? void 0 : _a.value;
                stockTab.filterText = ((_b = props.data.stockExchangeReleaseTabText) === null || _b === void 0 ? void 0 : _b.value) || textArr.find(text => text.language === props.currentLanguage).displayText;
                releases.push({ id: cat.id, icon: props.data.stockReleaseArticleIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
                defaultStockFilters.push(cat.id);
            }
            else if (cat.type === 'ShareBuyback') {
                stockTab.subIds.push({ id: cat.id, text: ((_c = props.data.shareBuybackFilterText) === null || _c === void 0 ? void 0 : _c.value) || textArr.find(text => text.language === props.currentLanguage).displayText });
                defaultStockFilters.push(cat.id);
            }
            else if (cat.type === 'ManagersTransactions') {
                stockTab.subIds.push({ id: cat.id, text: ((_d = props.data.managersTransactionsFilterText) === null || _d === void 0 ? void 0 : _d.value) || textArr.find(text => text.language === props.currentLanguage).displayText });
                defaultStockFilters.push(cat.id);
            }
            else if (cat.type === 'FlaggingNotification') {
                stockTab.subIds.push({ id: cat.id, text: ((_e = props.data.flaggingNotificationFilterText) === null || _e === void 0 ? void 0 : _e.value) || textArr.find(text => text.language === props.currentLanguage).displayText });
                defaultStockFilters.push(cat.id);
            }
            else if (cat.type === 'PressRelease') {
                pressTab.id = cat.id;
                pressTab.catname = cat.displayTexts[0].displayText.toLowerCase().replace(/\s|&/g, '');
                pressTab.resultText = (_f = props.data.showingPressText) === null || _f === void 0 ? void 0 : _f.value;
                pressTab.filterText = ((_g = props.data.pressReleaseTabText) === null || _g === void 0 ? void 0 : _g.value) || textArr.find(text => text.language === props.currentLanguage).displayText;
                releases.push({ id: cat.id, icon: props.data.pressReleaseArticleIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
            }
            else if (cat.type === 'NewsArticle') {
                newsTab.id = cat.id;
                newsTab.catname = cat.displayTexts[0].displayText.toLowerCase().replace(/\s|&/g, '');
                newsTab.resultText = (_h = props.data.showingNewsText) === null || _h === void 0 ? void 0 : _h.value;
                newsTab.filterText = ((_j = props.data.newsArticleTabText) === null || _j === void 0 ? void 0 : _j.value) || textArr.find(text => text.language === props.currentLanguage).displayText;
                releases.push({ id: cat.id, icon: props.data.newsArticleIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
                defaultNewsFilters.push(cat.id);
            }
            else if (cat.type === 'SustainabilityArticle') {
                const text = ((_k = props.data.sustainabilityArticleFilterText) === null || _k === void 0 ? void 0 : _k.value) || textArr.find(text => text.language === props.currentLanguage).displayText;
                newsTab.subIds.push({ id: cat.id, text: text });
                releases.push({ id: cat.id, icon: props.data.sustainabilityArticleIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
                defaultNewsFilters.push(cat.id);
            }
            else if (cat.type === 'OtherRelease') {
                const text = textArr.find(text => text.language === props.currentLanguage).displayText;
                releases.push({ id: cat.id, icon: props.data.otherReleaseIcon.value, catname: text });
            }
            if (cat.type === 'ShareBuyback')
                releases.push({ id: cat.id, icon: props.data.shareBuybackIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
            if (cat.type === 'ManagersTransactions')
                releases.push({ id: cat.id, icon: props.data.managersTransactionsIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
            if (cat.type === 'FlaggingNotification')
                releases.push({ id: cat.id, icon: props.data.shareBuybackIcon.value, catname: textArr.find(text => text.language === props.currentLanguage).displayText });
        });
    }
    const [stockFilterState, setStockFilterState] = (0, react_1.useState)(defaultStockFilters);
    const [newsFilterState, setNewsFilterState] = (0, react_1.useState)(defaultNewsFilters);
    const getYearAndMonthFilter = (year, month) => {
        let yearAndMonthFilter = '';
        if (year !== '' && month !== '') {
            const nextMonthString = +month + 1 < 10 ? `${year}-0${+month + 1}` : +month + 1 === 13 ? `${+year + 1}-01` : `${year}-${+month + 1}`;
            yearAndMonthFilter = `startPublish ge ${year}-${month !== '' ? month : '01'}-01T00:00:00Z and startPublish le ${nextMonthString}-01T00:00:00Z`;
        }
        else if (year !== '') {
            yearAndMonthFilter = `startPublish ge ${year}-01-01T00:00:00Z and startPublish le ${(+year + 1)}-01-01T00:00:00Z`;
        }
        return yearAndMonthFilter;
    };
    const getFilter = (category) => {
        var _a;
        let filter;
        let subFilter = '';
        let negSubFilter = '';
        const allFilter = 'ContentType/any(t:t eq \'PressReleasePage\')';
        // get it from incoming category
        if ((category === null || category === void 0 ? void 0 : category.id) && category.id !== '') {
            if (category.id === 'all')
                return allFilter;
            if (stockFilterState.includes(category.id) || newsFilterState.includes(category.id) || category.id === pressTab.id)
                filter = `categories/value/id eq ${category.id}`;
            if (((_a = category.subIds) === null || _a === void 0 ? void 0 : _a.length) > 0) {
                category.subIds.forEach(sub => {
                    if (stockFilterState.includes(sub.id) || newsFilterState.includes(sub.id)) {
                        if (subFilter === '')
                            subFilter = `categories/value/id eq ${sub.id}`;
                        else
                            subFilter = subFilter + ` or categories/value/id eq ${sub.id}`;
                    }
                    else {
                        if (negSubFilter === '')
                            negSubFilter = `categories/value/id ne ${sub.id}`;
                        else
                            negSubFilter = negSubFilter + ` and categories/value/id ne ${sub.id}`;
                    }
                });
            }
            if (filter && subFilter !== '')
                filter = `${filter} or ${subFilter}`;
            else if (!filter)
                filter = subFilter;
            if (filter && negSubFilter !== '')
                filter = `${filter}) and ${negSubFilter}`;
            else
                filter = `${filter})`;
            return `${allFilter} and (${filter}`;
        }
        // get it from URL
        const searchParams = new URLSearchParams(location.search);
        const selectedTab = searchParams.get('subject') || 'all';
        if (selectedTab === 'all')
            return allFilter;
        return `${allFilter} and (categories/value/id eq ${selectedTab})`;
    };
    const onTabSelect = (eventKey) => {
        var _a;
        let newTab;
        switch (eventKey) {
            case stockTab.id:
                newTab = stockTab;
                break;
            case pressTab.id:
                newTab = pressTab;
                break;
            case newsTab.id:
                newTab = newsTab;
                break;
            default:
                newTab = allBlogsTab;
                break;
        }
        if ((_a = props.data.updateUrl) === null || _a === void 0 ? void 0 : _a.value) {
            const url = new URL(window.location.href);
            if (newTab.id !== allBlogsTab.id) {
                url.searchParams.set('content', newTab.catname.toLowerCase().replace(/\s|&/g, ''));
                history.push(url.search);
            }
            else {
                url.searchParams.delete('content');
                history.push(`${url.pathname}${url.search}`);
            }
        }
        if (allBlogsTab.id === eventKey)
            newTab = allBlogsTab;
        toggleModal(false);
        setSelectedTab({ count: itemStep, skip: 0, filter: getFilter(newTab), yearAndMonthFilter: '', activeTab: newTab, query });
        (0, TabFunctions_1.toggleTabs)('tabnav', setIsTabsOpen);
    };
    const handleFilterChange = (id, isStock) => {
        let arr;
        if (isStock)
            arr = stockFilterState.slice(0);
        else
            arr = newsFilterState.slice(0);
        const index = arr.findIndex((e) => { return e === id; });
        if (index === -1)
            arr.push(id);
        else
            arr = arr.filter((e) => { return e !== id; });
        if (isStock)
            setStockFilterState(arr);
        else
            setNewsFilterState(arr);
        const newSelectedTab = Object.assign({}, selectedTab);
        newSelectedTab.skip = 0;
        setSelectedTab(newSelectedTab);
    };
    const filterActive = (id, isStock) => {
        let index = -1;
        if (isStock)
            index = stockFilterState.findIndex((e) => { return e === id; });
        else
            index = newsFilterState.findIndex((e) => { return e === id; });
        return index !== -1;
    };
    const handleYearlyFilters = (year, month) => {
        toggleModal(false);
        const newSelectedTab = { count: itemStep, skip: 0, filter: getFilter(selectedTab.activeTab), yearAndMonthFilter: getYearAndMonthFilter(year, month), activeTab: selectedTab.activeTab, query };
        setSelectedTab(newSelectedTab);
    };
    const createSubFilters = (tab) => {
        let filters = [];
        filters.push(react_1.default.createElement("div", { key: tab.id, className: 'col-auto pb-2' },
            react_1.default.createElement("input", { className: 'me-2', type: "checkbox", id: `filter-${tab.id}`, name: tab.filterText, value: tab.id, checked: filterActive(tab.id, tab.id === stockTab.id), onChange: (e) => handleFilterChange(e.target.value, tab.id === stockTab.id) }),
            react_1.default.createElement("label", { htmlFor: `filter-${tab.id}` }, tab.filterText)));
        tab === null || tab === void 0 ? void 0 : tab.subIds.forEach(sub => {
            var _a;
            filters.push(react_1.default.createElement("div", { key: sub.id, className: 'col-auto pb-2' },
                react_1.default.createElement("input", { className: 'me-2', type: "checkbox", id: `filter-${sub.id}`, name: sub.text.substring(((_a = sub.text) === null || _a === void 0 ? void 0 : _a.lastIndexOf('/')) + 2), value: sub.id, checked: filterActive(sub.id, tab.id === stockTab.id), onChange: (e) => handleFilterChange(e.target.value, tab.id === stockTab.id) }),
                react_1.default.createElement("label", { htmlFor: `filter-${sub.id}` }, sub.text)));
        });
        return filters;
    };
    const toggleModal = (toggle) => {
        if (toggle)
            handleYearlyFilters('', '');
        setShowReleaseFilter(toggle);
    };
    const getResultText = () => {
        if (selectedTab.activeTab.id === stockTab.id)
            return stockTab.resultText;
        if (selectedTab.activeTab.id === pressTab.id)
            return pressTab.resultText;
        if (selectedTab.activeTab.id === newsTab.id)
            return newsTab.resultText;
        if (selectedTab.activeTab.id === allBlogsTab.id)
            return allBlogsTab.resultText;
    };
    const buildTabs = (tab) => {
        var _a, _b;
        if (tab.id !== '' && tab.filterText !== '') {
            let filters = [];
            if (tab.id === stockTab.id)
                filters = createSubFilters(stockTab);
            if (tab.id === newsTab.id)
                filters = createSubFilters(newsTab);
            tabContent.push(react_1.default.createElement(react_bootstrap_1.Tab, { eventKey: tab.id, key: tab.id, title: tab.filterText },
                filters.length > 0 &&
                    react_1.default.createElement("div", { className: 'row pt-7' },
                        react_1.default.createElement("div", { className: 'col-12 col-sm-auto pb-3 pb-sm-0 text-dark-gray', id: 'subfilters' },
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'showText' })),
                        react_1.default.createElement("div", { className: 'col-12 col-sm' },
                            react_1.default.createElement("div", { className: 'row', "aria-labelledby": 'subfilters' }, filters))),
                react_1.default.createElement("div", { className: 'row align-items-center pt-8 pt-sm-9' },
                    react_1.default.createElement("div", { className: 'col-12 col-sm pb-7 pb-sm-0' },
                        react_1.default.createElement("p", { className: 'semibold mb-0 no-outline', tabIndex: -1, id: 'resulttext' }, totalReleases !== '' ?
                            react_1.default.createElement(react_1.default.Fragment, null,
                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'showingText' }),
                                ` ${props.currentLanguage === 'en' ? totalReleases.replace(/\B(?=(\d{3})+(?!\d))/g, ",") : totalReleases.replace(/\B(?=(\d{3})+(?!\d))/g, " ")} `,
                                getResultText()) :
                            react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: 'noResultsText' }))),
                    react_1.default.createElement("div", { className: 'col-auto position-relative' },
                        react_1.default.createElement(Button_1.default, { id: 'monthFilter', type: Button_1.ButtonType.Outline, iconClass: 'icon-arrow-down-tail', onClick: () => toggleModal(!showReleaseFilter), title: selectedTab.yearAndMonthFilter !== '' ? (_a = props.data.filterActive) === null || _a === void 0 ? void 0 : _a.value : (_b = props.data.allDatesText) === null || _b === void 0 ? void 0 : _b.value }),
                        tab.id === selectedTab.activeTab.id &&
                            react_1.default.createElement("div", { className: 'col-auto position-absolute month-filter-wrapper' },
                                react_1.default.createElement(ReleasesMonthFilter_1.default, { show: showReleaseFilter, close: toggleModal, query: selectedTab.query, filter: getFilter(selectedTab.activeTab), language: language, setYear: handleYearlyFilters, labelSettings: labelSettings }))),
                    react_1.default.createElement("div", { className: 'col-12' },
                        react_1.default.createElement("div", { className: 'border-light-gray pb-9' }))),
                react_1.default.createElement("ul", { className: 'row p-0 m-0' }, tab.content)));
        }
    };
    const resultItem = (data) => {
        var _a, _b, _c, _d, _e;
        let release;
        let categoryNames = [];
        (_a = data === null || data === void 0 ? void 0 : data.categories) === null || _a === void 0 ? void 0 : _a.value.sort(function (a, b) {
            try {
                if (a.id < b.id) {
                    return -1;
                }
                if (a.id > b.id) {
                    return 1;
                }
                return 0;
            }
            catch (_a) {
                //ignore on purpose
            }
        });
        let isNewsArticle = false;
        (_b = data === null || data === void 0 ? void 0 : data.categories) === null || _b === void 0 ? void 0 : _b.value.forEach((cat) => {
            if (!isNewsArticle && newsTab.id === cat.id.toString()) {
                isNewsArticle = true;
            }
            release = releases.find(item => {
                return item.id === cat.id.toString();
            });
            if (release !== undefined)
                categoryNames.push(release.catname);
        });
        return react_1.default.createElement("li", { className: 'col-12 px-0 pt-8 pb-6 py-sm-9 border-light-gray', key: data.contentLink.id },
            react_1.default.createElement("a", Object.assign({ href: `${data.contentLink.url}${location.search}`, className: 'row', title: (_c = data.releaseTitle) === null || _c === void 0 ? void 0 : _c.value }, (((_d = data.releaseLanguage) === null || _d === void 0 ? void 0 : _d.value) !== '' ? { lang: (_e = data.releaseLanguage) === null || _e === void 0 ? void 0 : _e.value } : null)),
                (release === null || release === void 0 ? void 0 : release.icon) && (release === null || release === void 0 ? void 0 : release.icon) !== '' &&
                    react_1.default.createElement("span", { "aria-hidden": true, className: `col-12 col-sm-auto ${release.icon} d-block pb-6 pb-sm-0 pe-9` }),
                react_1.default.createElement("span", { className: 'col d-block' },
                    react_1.default.createElement("h3", null, data.releaseTitle.value),
                    react_1.default.createElement("span", { className: 'd-block release-info' },
                        react_1.default.createElement("span", null, categoryNames.join(' / ')),
                        react_1.default.createElement("span", { className: 'px-2' }, "|"),
                        " ",
                        react_1.default.createElement("span", null, isNewsArticle ? (0, date_utils_1.getFormatedGeneralDate)(data.startPublish, language, true) : (0, date_utils_1.getFormatedGeneralDatetime)(data.startPublish, language, true))))));
    };
    const populateTabs = (releases) => {
        releases.results.forEach((release) => {
            if (selectedTab.activeTab.id === allBlogsTab.id)
                allBlogsTab.content.push(resultItem(release));
            if (selectedTab.activeTab.id === stockTab.id)
                stockTab.content.push(resultItem(release));
            if (selectedTab.activeTab.id === pressTab.id)
                pressTab.content.push(resultItem(release));
            if (selectedTab.activeTab.id === newsTab.id)
                newsTab.content.push(resultItem(release));
        });
    };
    if (childrens) {
        populateTabs(childrens);
        buildTabs(allBlogsTab);
        buildTabs(stockTab);
        buildTabs(pressTab);
        buildTabs(newsTab);
        tabElement = react_1.default.createElement("div", { className: 'col-12 position-relative' },
            react_1.default.createElement("div", { className: 'd-block d-sm-none tab-button' },
                react_1.default.createElement(Button_1.default, { type: Button_1.ButtonType.Outline, iconClass: 'icon-arrow-right-tail', onClick: () => (0, TabFunctions_1.toggleTabs)('tabnav', setIsTabsOpen), title: selectedTab.activeTab.filterText, ariacontrols: 'tabnav', ariaexpanded: isTabsOpen })),
            react_1.default.createElement(react_bootstrap_1.Tabs, { onSelect: onTabSelect, defaultActiveKey: selectedTab.activeTab.id || 'all', id: "releasetabs" }, tabContent));
    }
    const getMoreBlocks = () => {
        const skip = selectedTab.skip + itemStep;
        const newSelectedTab = { count: itemStep, skip: skip, filter: getFilter(selectedTab.activeTab), yearAndMonthFilter: selectedTab.yearAndMonthFilter, activeTab: selectedTab.activeTab, query };
        setSelectedTab(newSelectedTab);
    };
    const search = (event) => {
        var _a;
        //(document.querySelector('.release-search') as HTMLElement).blur()
        if (event)
            event.preventDefault();
        const newSelectedTab = { count: itemStep, skip: 0, filter: getFilter(selectedTab.activeTab), yearAndMonthFilter: selectedTab.yearAndMonthFilter, activeTab: selectedTab.activeTab, query: query };
        if ((_a = props.data.updateUrl) === null || _a === void 0 ? void 0 : _a.value) {
            const url = new URL(window.location.href);
            url.searchParams.set('query', query);
            history.push(url.search);
        }
        setSelectedTab(newSelectedTab);
    };
    const clearSearch = () => {
        setQuery('');
        const url = new URL(window.location.href);
        url.searchParams.delete('query');
        history.push(`${url.pathname}${url.search}`);
        const newSelectedTab = { count: itemStep, skip: 0, filter: getFilter(selectedTab.activeTab), yearAndMonthFilter: selectedTab.yearAndMonthFilter, activeTab: selectedTab.activeTab, query: '' };
        setSelectedTab(newSelectedTab);
        try {
            document.querySelector('form input').focus();
        }
        catch (_a) { }
    };
    const handleInputKeyDown = (e) => {
        if (e.code === 'Enter' && query !== '') {
            document.querySelector('.release-search').blur();
            e.preventDefault();
            e.stopPropagation();
            search();
        }
    };
    (0, react_1.useEffect)(() => {
        var _a;
        let isCancelled = false;
        if (language !== undefined && ((_a = layoutSettings === null || layoutSettings === void 0 ? void 0 : layoutSettings.language) === null || _a === void 0 ? void 0 : _a.name) !== language) {
            settingsService.getContainer('LayoutSettings').then(x => {
                if (isCancelled)
                    return;
                setLayoutSettings(x);
            });
            settingsService.getContainer('LabelSettings').then(x => {
                if (isCancelled)
                    return;
                setLabelSettings(x);
            });
            settingsService.getContainer('Categories').then(x => {
                if (isCancelled)
                    return;
                setCategoryList(x);
            });
        }
        if (firstload)
            setFirstLoad(false);
        else {
            const tabnav = document.querySelector('[role=tablist]');
            if (tabnav)
                tabnav.setAttribute('id', 'tabnav');
            let filter = getFilter(selectedTab.activeTab);
            const monthFilter = selectedTab.yearAndMonthFilter;
            if (filter !== '' && monthFilter !== '')
                filter = filter + ' and ' + monthFilter;
            if (filter === '' && monthFilter !== '')
                filter = monthFilter;
            if ((selectedTab.activeTab.id === stockTab.id && stockFilterState.length === 0) || (selectedTab.activeTab.id === newsTab.id && newsFilterState.length === 0)) {
                setChildrens({ totalMatching: 0, results: Array(0) });
                setTotalReleases('0');
                setDisableShowMore(true);
            }
            else {
                setLoading(true);
                api.basicSearch(selectedTab.query, filter, 'startPublish desc', selectedTab.skip, selectedTab.count, false).then(x => {
                    if (isCancelled)
                        return;
                    if (childrens !== undefined) {
                        if (selectedTab.skip > 0)
                            x.results = childrens.results.concat(x.results);
                    }
                    setChildrens(x);
                    setTotalReleases(x.totalMatching.toString());
                    setDisableShowMore(x.totalMatching <= x.results.length);
                    setLoading(false);
                });
            }
        }
        return () => {
            isCancelled = true;
            localStorage.setItem('releaseSearchQuery', JSON.stringify({ search: location.search }));
        };
    }, [language, selectedTab, stockFilterState, newsFilterState]);
    (0, react_1.useEffect)(() => {
        const tabnav = document.querySelector('[role=tablist]');
        if (tabnav)
            tabnav.setAttribute('id', 'tabnav');
        if (selectedTab.query !== '')
            try {
                if (!ctx.isInEditMode())
                    document.querySelector('#resulttext').focus();
            }
            catch (_a) { }
    }, [childrens]);
    (0, react_1.useEffect)(() => {
        if (!ctx.isInEditMode() && document.activeElement.id !== 'contentRow')
            document.querySelector('#heading-section').focus({ preventScroll: true });
    }, [props.contentLink.id]);
    (0, react_1.useEffect)(() => {
        const searchParams = new URLSearchParams(location.search);
        const contentparams = searchParams.get('content');
        const query = searchParams.get('query');
        let newTab;
        if (contentparams) {
            const content = decodeURI(contentparams);
            switch (content) {
                case stockTab.catname.toLowerCase().replace(/\s|&/g, ''):
                    newTab = stockTab;
                    break;
                case pressTab.catname.toLowerCase().replace(/\s|&/g, ''):
                    newTab = pressTab;
                    break;
                case newsTab.catname.toLowerCase().replace(/\s|&/g, ''):
                    newTab = newsTab;
                    break;
                default:
                    newTab = allBlogsTab;
                    break;
            }
        }
        else {
            newTab = selectedTab.activeTab;
        }
        if (query)
            setQuery(query);
        setSelectedTab({ count: itemStep, skip: 0, filter: getFilter(newTab), yearAndMonthFilter: '', activeTab: newTab, query: query ? query : '' });
    }, []);
    let title = ((_f = (_e = props.data) === null || _e === void 0 ? void 0 : _e.metaTitle) === null || _f === void 0 ? void 0 : _f.value) || (typeof ((_g = props.data) === null || _g === void 0 ? void 0 : _g.name) === 'string' ? props.data.name : (_j = (_h = props.data) === null || _h === void 0 ? void 0 : _h.name) === null || _j === void 0 ? void 0 : _j.value);
    if (!layoutSettings || !labelSettings || !categoryList)
        return react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, null);
    const langtags = [];
    ((_k = props.data.existingLanguages) === null || _k === void 0 ? void 0 : _k.length) > 1 &&
        props.data.existingLanguages.forEach(l => {
            langtags.push(react_1.default.createElement("link", { href: l.link, hrefLang: l.name, rel: "alternate", key: l.name }));
        });
    return react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_helmet_1.default, null,
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("link", { rel: "canonical", href: ((_l = props.data.canonicalUrl) === null || _l === void 0 ? void 0 : _l.value) ? `${ctx.getEpiserverURL()}${props.data.canonicalUrl.value}` : props.data.url }),
            ((_m = props.data.keywords) === null || _m === void 0 ? void 0 : _m.value) &&
                react_1.default.createElement("meta", { name: "keywords", content: props.data.keywords.value }),
            react_1.default.createElement("meta", { name: "description", content: ((_p = (_o = props.data) === null || _o === void 0 ? void 0 : _o.pageDescription) === null || _p === void 0 ? void 0 : _p.value) || (((_q = layoutSettings.companyDesc) === null || _q === void 0 ? void 0 : _q.value) ? (_r = layoutSettings.companyDesc) === null || _r === void 0 ? void 0 : _r.value : layoutSettings.companyDesc) }),
            react_1.default.createElement("meta", { property: "og:url", content: window.location.href }),
            react_1.default.createElement("meta", { property: "og:type", content: ((_s = props.data.metaContentType) === null || _s === void 0 ? void 0 : _s.value) || 'website' }),
            react_1.default.createElement("meta", { property: "og:title", content: title }),
            react_1.default.createElement("meta", { property: "og:description", content: ((_u = (_t = props.data) === null || _t === void 0 ? void 0 : _t.pageDescription) === null || _u === void 0 ? void 0 : _u.value) || (((_v = layoutSettings.companyDesc) === null || _v === void 0 ? void 0 : _v.value) ? (_w = layoutSettings.companyDesc) === null || _w === void 0 ? void 0 : _w.value : layoutSettings.companyDesc) }),
            ((_y = (_x = layoutSettings.facebookShareImage) === null || _x === void 0 ? void 0 : _x.value) === null || _y === void 0 ? void 0 : _y.url) &&
                react_1.default.createElement("meta", { property: "og:image", content: layoutSettings.facebookShareImage.value.url }),
            ((_0 = (_z = layoutSettings.twitterShareImage) === null || _z === void 0 ? void 0 : _z.value) === null || _0 === void 0 ? void 0 : _0.url) &&
                react_1.default.createElement("meta", { property: "twitter:image", content: layoutSettings.twitterShareImage.value.url }),
            react_1.default.createElement("meta", { name: "twitter:card", content: "summary" }),
            ((_1 = props.data.existingLanguages) === null || _1 === void 0 ? void 0 : _1.length) > 1 &&
                react_1.default.createElement("link", { href: props.data.url, hrefLang: "x-default", rel: "alternate" }),
            ((_2 = props.data.existingLanguages) === null || _2 === void 0 ? void 0 : _2.length) > 1 && langtags,
            ((_3 = props.data.jsonLdSchema) === null || _3 === void 0 ? void 0 : _3.value) && props.data.jsonLdSchema.value.trim() !== '' &&
                react_1.default.createElement("script", { type: "application/ld+json" }, props.data.jsonLdSchema.value)),
        react_1.default.createElement("main", { className: 'page position-relative release-search-page', tabIndex: -1 },
            react_1.default.createElement(PageTop_1.default, { layoutSettings: layoutSettings, showNews: props.data.showPageTopNews.value, breadCrumbsProps: props.data, lang: language }),
            react_1.default.createElement(Glossary_1.default, { labelSettings: labelSettings, useGlossary: props.data.useGlossary.value, useShare: props.data.useShare.value }),
            react_1.default.createElement("div", { className: 'row g-0' },
                react_1.default.createElement("div", { className: 'block layout col-12' },
                    react_1.default.createElement("div", { className: 'mt-9 mt-md-10 pt-md-11 pb-8 pb-md-10' },
                        react_1.default.createElement("div", { className: 'row align-items-baseline' },
                            react_1.default.createElement("div", { className: 'col-12 col-sm-8 col-lg-6 no-outline', id: 'heading-section', tabIndex: -1 },
                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: props.data, field: "mainBody" })),
                            react_1.default.createElement("div", { className: 'col-12 col-sm top-corner-link' },
                                react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.topCornerLink, propertyName: "topCornerLink", defaultRowClass: 'row g-0 justify-content-sm-end' })))))),
            react_1.default.createElement("section", { "aria-label": ((_4 = props.data.searchAndNavAriaLabel) === null || _4 === void 0 ? void 0 : _4.value) || 'search area' },
                react_1.default.createElement("div", { className: 'row g-0' },
                    react_1.default.createElement("div", { className: 'block layout col-12' },
                        react_1.default.createElement("div", { className: 'mb-9 mb-md-10' },
                            react_1.default.createElement("div", { className: 'search-form col-12' },
                                react_1.default.createElement("form", { className: 'position-relative', onSubmit: e => { search(e); } },
                                    react_1.default.createElement("label", { className: 'w-100' },
                                        react_1.default.createElement("input", { placeholder: (_5 = props.data.searchInputPlaceholder) === null || _5 === void 0 ? void 0 : _5.value, className: 'release-search w-100 border-0 border-bottom border-black pb-2 ingress', type: "text", value: query, onChange: e => setQuery(e.target.value), onKeyDown: e => handleInputKeyDown(e) })),
                                    react_1.default.createElement("div", { className: 'position-absolute end-0 bottom-0 pe-sm-3 pb-1' },
                                        react_1.default.createElement("button", { className: 'icon-button border-0 bg-transparent d-inline-flex align-items-center', type: "button", onClick: () => clearSearch() },
                                            react_1.default.createElement("span", { className: 'text-black icon-x', "aria-hidden": true }),
                                            react_1.default.createElement("span", { className: 'visually-hidden' },
                                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: "clearText" }))),
                                        react_1.default.createElement("span", { className: 'spacer' }),
                                        react_1.default.createElement("button", { className: 'icon-button border-0 bg-transparent d-inline-flex align-items-center', type: "submit" },
                                            react_1.default.createElement("span", { className: 'icon-search text-black', "aria-hidden": true }),
                                            react_1.default.createElement("span", { className: 'visually-hidden' },
                                                react_1.default.createElement(spa_core_1.Components.Property, { iContent: labelSettings, field: 'searchButtonText' })))))))))),
            react_1.default.createElement("section", { "aria-label": ((_6 = props.data.releaseTabsAriaLabel) === null || _6 === void 0 ? void 0 : _6.value) || 'releases and news tabs' },
                react_1.default.createElement("div", { className: 'row g-0' },
                    react_1.default.createElement("div", { className: 'block layout col-12' },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("div", { className: 'row mb-8 mb-md-9' }, tabElement),
                            childrens &&
                                react_1.default.createElement("div", { className: 'row text-center mb-9 mb-sm-10 ' },
                                    react_1.default.createElement("div", { className: 'col-12' },
                                        react_1.default.createElement(Button_1.default, { disabled: disableShowMore, type: Button_1.ButtonType.Outline, iconClass: 'icon-arrow-down-tail', onClick: () => getMoreBlocks(), title: (_7 = props.data.showMoreButtonText) === null || _7 === void 0 ? void 0 : _7.value }))))),
                    loading &&
                        react_1.default.createElement("div", { className: 'position-absolute w-100 h-100 top-0 d-flex justify-content-center' },
                            react_1.default.createElement(LoadingSpinner_1.LoadingSpinner, null)))),
            react_1.default.createElement(spa_core_1.Components.ContentArea, { animate: true, data: props.data.mainContentArea, propertyName: "mainContentArea" }),
            react_1.default.createElement(spa_core_1.Components.ContentArea, { data: props.data.bottomContentArea, propertyName: "bottomContentArea" })),
        react_1.default.createElement(GlossaryService_1.default, { glossaryActive: props.glossaryOpen && props.data.useGlossary.value, settings: layoutSettings }));
};
exports.DefaultReleaseSearchPage = DefaultReleaseSearchPage;
exports.ConnectedReleaseSearchPage = (0, react_redux_1.connect)((state, ownProps) => {
    const propsFromState = state.OptiContentCloud || {};
    const propsFromAppState = state.ApplicationStates || {};
    return Object.assign(Object.assign(Object.assign({}, ownProps), propsFromState), propsFromAppState);
})(exports.DefaultReleaseSearchPage);
const ReleaseSearchPage = (props) => {
    const ctx = (0, spa_core_1.useEpiserver)();
    if (ctx.isServerSideRendering())
        return react_1.default.createElement(exports.DefaultReleaseSearchPage, Object.assign({}, props));
    return react_1.default.createElement(exports.ConnectedReleaseSearchPage, Object.assign({}, props));
};
exports.default = ReleaseSearchPage;
